module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a06-12aaeef90dd826031e0091082e015f4e.jpg";